import { trigger, state, style, transition, animate } from '@angular/animations';

export const slideFadeAnimation = trigger('slideFade', [
    state('expand', style({ transform: 'translateY(-5px)' })),
    state('collapse', style({ transform: 'translateY(0)' })),
    transition('collapse => expand', [
        animate('320ms ease-in')
    ]),
    transition('expand => collapse', [
        animate('300ms ease-in')
    ])
]);